import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './App.css';
import './Assets/Css/bootstrap.min.css';
import './Assets/Css/variable.css';
import './Assets/Css/style.css';
import PublicRoutes from './Routes/PublicRoutes';
import UserRoutes from './Routes/UserRoutes';
import { LoaderIcon } from './Constant/Index';
function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate an API call or any asynchronous operation
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  // Custom Cursor


  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  // Update cursor position based on mouse movement
  const updateCursorPosition = (e) => {
    setCursorPosition({ x: e.clientX, y: e.clientY });
  };

  useEffect(() => {
    // Add event listeners for mouse movement
    window.addEventListener('mousemove', updateCursorPosition);

    return () => {
      // Clean up event listeners on unmount
      window.removeEventListener('mousemove', updateCursorPosition);
    };
  }, []);

  return (
    <>
      <div
        className="custom-cursor"
        style={{ left: cursorPosition.x, top: cursorPosition.y }}
      ></div>
      {loading ? (
        <>
          <div className="preloader" >
            <img src={LoaderIcon} alt="" />
          </div>
        </>
      ) : (
        <div>
          <PublicRoutes />
          <UserRoutes />
        </div>
      )}
    </>
  );
}

export default App;
